import React from 'react'
// import GSTSalesRegister from '../../components/reports/GSTSalesRegister';
import ReportView from '../../components/reports/reportView';
const Report = () => {
  return (
    <div>

      {/* <div className='report--wrapper'>
        <GSTSalesRegister />
      </div> */}
      <div className='report--wrapper'>
        <ReportView />
        </div>

      
    </div>
  )
}

export default Report
